import { useEffect, useState } from "react";

export default function useGetCurrentDmxDrugTab(tabType, styleConfig) {
  const [currentDmxDrugTab, setCurrentDmxDrugTab] = useState(null);
  const isDmxGeneralDrugMonograph = styleConfig?.isDmxGeneralDrugMonograph;

  useEffect(() => {
    if (isDmxGeneralDrugMonograph) {
      setCurrentDmxDrugTab(
        tabType === "details" ? "IN-DEPTH ANSWERS" : "QUICK ANSWERS"
      );
    } else {
      setCurrentDmxDrugTab(null);
    }
  }, [tabType, isDmxGeneralDrugMonograph]);

  return { currentDmxDrugTab };
}
